import layoutHeaderAside from '@/layout/header-aside'

// 由于懒加载页面太多的话会造成webpack热更新太慢，所以开发环境不使用懒加载，只有生产环境使用懒加载
const _import = require('@/libs/util.import.' + process.env.NODE_ENV)

/**
 * 在主框架内显示
 */
const frameIn = [{
  path: '/',
  redirect: {
    name: 'index'
  },
  component: layoutHeaderAside,
  children: [
    // 首页
    {
      path: 'index',
      name: 'index',
      meta: {
        auth: true
      },
      component: _import('system/index')
    },
    // 系统 前端日志
    {
      path: 'log',
      name: 'log',
      meta: {
        title: '前端日志',
        auth: true
      },
      component: _import('system/log')
    },
    // 刷新页面 必须保留
    {
      path: 'refresh',
      name: 'refresh',
      hidden: true,
      component: _import('system/function/refresh')
    },
    // 页面重定向 必须保留
    {
      path: 'redirect/:route*',
      name: 'redirect',
      hidden: true,
      component: _import('system/function/redirect')
    },
    // 自定义页面
    {
      path: "/admin",
      name: "admin",
      component: _import("admin/index.vue"),
      meta: {
        auth: true,
        title: "系统管理"
      }
    },
    {
      path: "/admin/add",
      name: "admin-dd",
      component: _import("admin/add.vue"),
      meta: {
        auth: true,
        title: "新增系统管理员"
      }
    },
    // 公告管理
    {
      path: "/notes",
      name: "notes",
      component: _import("notes/index.vue"),
      meta: {
        auth: true,
        title: "公告管理"
      }
    },
    {
      path: "/notes/add",
      name: "notes-add",
      component: _import("notes/add.vue"),
      meta: {
        auth: true,
        title: "新增公告"
      }
    },
    {
      path: "/notes/edit/:id",
      name: "notes-edit",
      component: _import("notes/edit.vue"),
      meta: {
        auth: true,
        title: "编辑公告"
      }
    },
    //资源管理
    {
      path: "/resource",
      name: "resource",
      component: _import("resource/index.vue"),
      meta: {
        auth: true,
        title: "图鉴管理"
      }
    },
    {
      path: "/resource/add",
      name: "resource-dd",
      component: _import("resource/add.vue"),
      meta: {
        auth: true,
        title: "新增图鉴"
      }
    },
    {
      path: "/resource/edit/:id",
      name: "resource-edit",
      component: _import("resource/edit.vue"),
      meta: {
        auth: true,
        title: "编辑图鉴"
      }
    },
    //映射管理
    {
      path: "/mapping",
      name: "mapping",
      component: _import("mapping/index.vue"),
      meta: {
        auth: true,
        title: "映射管理"
      }
    },
    {
      path: "/mapping/edit",
      name: "mapping-edit",
      component: _import("mapping/edit.vue"),
      meta: {
        auth: true,
        title: "映射Token设置"
      }
    },
    {
      path: "/mapping/edit/:id",
      name: "mapping-edit",
      component: _import("mapping/edit.vue"),
      meta: {
        auth: true,
        title: "映射Token设置"
      }
    },
    //手续费管理
    {
      path: "/fee",
      name: "fee",
      component: _import("fee/index.vue"),
      meta: {
        auth: true,
        title: "手续费管理"
      }
    },
    {
      path: "/fee/edit",
      name: "fee-edit",
      component: _import("fee/edit.vue"),
      meta: {
        auth: true,
        title: "手续费设置"
      }
    },
    {
      path: "/fee/edit/:id",
      name: "fee-edit",
      component: _import("fee/edit.vue"),
      meta: {
        auth: true,
        title: "手续费设置"
      }
    },
    //交易时间管理
    {
      path: "/time",
      name: "time",
      component: _import("time/index.vue"),
      meta: {
        auth: true,
        title: "交易时间管理"
      }
    },
    {
      path: "/time/edit",
      name: "time-edit",
      component: _import("time/edit.vue"),
      meta: {
        auth: true,
        title: "交易时间设置"
      }
    },
    {
      path: "/time/edit/:id",
      name: "time-edit",
      component: _import("time/edit.vue"),
      meta: {
        auth: true,
        title: "交易时间设置"
      }
    },



    {
      path: "/transaction",
      name: "transaction",
      component: _import("transaction/index.vue"),
      meta: {
        auth: true,
        title: "全部交易"
      }
    },
    {
      path: "/tx-nos",
      name: "tx-nos",
      component: _import("transaction/tx_NOS.vue"),
      meta: {
        auth: true,
        title: "NOS交易"
      }
    },
    {
      path: "/tx-usdt",
      name: "tx-usdt",
      component: _import("transaction/tx_USDT.vue"),
      meta: {
        auth: true,
        title: "USDT交易"
      }
    },



    {
      path: "/balanceTool",
      name: "balanceTool",
      component: _import("balanceTool/index.vue"),
      meta: {
        auth: true,
        title: "资产插叙工具"
      }
    },
  ]
}]

/**
 * 在主框架之外显示
 */
const frameOut = [
  // 登录
  {
    path: '/login',
    name: 'login',
    component: _import('system/login')
  }
]

/**
 * 错误页面
 */
const errorPage = [{
  path: '*',
  name: '404',
  component: _import('system/error/404')
}]

// 导出需要显示菜单的
export const frameInRoutes = frameIn

// 重新组织后导出
export default [
  ...frameIn,
  ...frameOut,
  ...errorPage
]